(function () {
  if (window.__epicLandingPagesInit) return;
  window.__epicLandingPagesInit = true;

  var groups = {};
  var bedsGroups = {};

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }

    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function buildSaveText(variant) {
    var compareAt = Number(variant.compare_at_price || 0);
    var price = Number(variant.price || 0);

    if (!compareAt || compareAt <= price) return '';

    return 'Save ' + Math.round(((compareAt - price) / compareAt) * 100) + '%';
  }

  function parseVariants(root) {
    var node = root.querySelector('[data-variants-json]');
    if (!node) return [];

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error('[landing-page-templates] Unable to parse variants', error);
      return [];
    }
  }

  function parseJsonNode(root, selector, fallbackValue) {
    var node = root.querySelector(selector);
    if (!node) return fallbackValue;

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error('[landing-page-templates] Unable to parse JSON for selector', selector, error);
      return fallbackValue;
    }
  }

  function parseVariantContent(root) {
    var node = root.querySelector('[data-variant-content-html]');
    if (!node) return {};

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error('[landing-page-templates] Unable to parse variant content', error);
      return {};
    }
  }

  function parseVariantHeadings(root) {
    var node = root.querySelector('[data-variant-heading-text]');
    if (!node) return {};

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error('[landing-page-templates] Unable to parse variant headings', error);
      return {};
    }
  }

  function initMediaGallery(root) {
    var gallery = root.querySelector('[data-lp-media-gallery]');
    if (!gallery) return null;

    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.lp-shell__media-slide[data-media-key]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-media-thumb]'));
    var prevButton = gallery.querySelector('[data-lp-media-prev]');
    var nextButton = gallery.querySelector('[data-lp-media-next]');
    if (!slides.length) return null;

    var activeKey = String(gallery.dataset.initialMediaKey || slides[0].dataset.mediaKey || '');

    function updateButtons(index) {
      if (prevButton) prevButton.disabled = index <= 0;
      if (nextButton) nextButton.disabled = index >= slides.length - 1;
    }

    function setActive(mediaKey) {
      var normalizedKey = String(mediaKey || '');
      var nextIndex = slides.findIndex(function (slide) {
        return String(slide.dataset.mediaKey || '') === normalizedKey;
      });

      if (nextIndex < 0) nextIndex = 0;
      activeKey = String(slides[nextIndex].dataset.mediaKey || '');

      slides.forEach(function (slide, index) {
        var isActive = index === nextIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      thumbs.forEach(function (thumb) {
        var isActive = String(thumb.dataset.mediaKey || '') === activeKey;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        if (isActive) {
          thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      });

      updateButtons(nextIndex);
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        var currentIndex = slides.findIndex(function (slide) {
          return String(slide.dataset.mediaKey || '') === activeKey;
        });
        setActive(slides[Math.max(0, currentIndex - 1)].dataset.mediaKey);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        var currentIndex = slides.findIndex(function (slide) {
          return String(slide.dataset.mediaKey || '') === activeKey;
        });
        setActive(slides[Math.min(slides.length - 1, currentIndex + 1)].dataset.mediaKey);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setActive(thumb.dataset.mediaKey);
      });
    });

    setActive(activeKey);

    return {
      setActive: setActive
    };
  }

  function syncButtonState(button, variant) {
    if (!button) return;

    var soldOutText = button.dataset.soldOutText || 'Sold out';
    var defaultText = button.dataset.defaultText || button.textContent.trim();
    var textNode =
      button.querySelector('.add-to-cart-text') ||
      button.querySelector('[data-add-to-cart-text]') ||
      button.querySelector('span');

    if (textNode && !button.dataset.defaultText) {
      button.dataset.defaultText = defaultText;
    }

    button.disabled = !variant || !variant.available;
    button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');

    if (textNode) {
      textNode.textContent = variant && variant.available ? defaultText : soldOutText;
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getBedsProduct(group) {
    if (!group.catalog || !group.catalog.products) return null;
    return group.catalog.products[group.state.space + '-' + group.state.height] || null;
  }

  function getBedsVariant(product, group) {
    if (!product || !product.variants || !product.variants.length) return null;

    var byTitle = null;
    if (group.state.variantTitle) {
      byTitle = product.variants.find(function (variant) {
        return String(variant.title) === String(group.state.variantTitle);
      });
    }

    return byTitle || product.variants.find(function (variant) {
      return variant.available;
    }) || product.variants[0];
  }

  function syncBedsButton(button, variant) {
    syncButtonState(button, variant);
  }

  function resolveBedsMediaIndex(product, selectedVariant) {
    if (!product || !product.media || !product.media.length) return 0;
    if (!selectedVariant || !selectedVariant.image) return 0;

    var nextIndex = product.media.findIndex(function (mediaItem) {
      return mediaItem.image === selectedVariant.image;
    });

    return nextIndex >= 0 ? nextIndex : 0;
  }

  function renderBedsGallery(root, product, selectedVariant, group) {
    var gallery = root.querySelector('[data-lp-beds-gallery]');
    var stage = root.querySelector('[data-lp-beds-gallery-stage]');
    if (!gallery || !stage) return;

    var prevButton = root.querySelector('[data-lp-beds-gallery-prev]');
    var nextButton = root.querySelector('[data-lp-beds-gallery-next]');
    var thumbs = root.querySelector('[data-lp-beds-gallery-thumbs]');
    var showProductMedia = group.state.hasInteracted === true;
    var items = [];

    if (showProductMedia && product && product.media && product.media.length) {
      items = product.media.slice();
    } else {
      items = [{
        image: root.dataset.defaultHeroImage || (product && product.image) || '',
        imageAlt: root.dataset.defaultHeroImageAlt || (product && product.imageAlt) || ''
      }];
    }

    if (!items.length || !items[0].image) return;

    if (!showProductMedia) {
      root._lpBedsGalleryIndex = 0;
    } else if (root.dataset.lpBedsGalleryHandle !== product.handle) {
      root._lpBedsGalleryIndex = resolveBedsMediaIndex(product, selectedVariant);
    } else if (typeof root._lpBedsGalleryIndex !== 'number') {
      root._lpBedsGalleryIndex = 0;
    }

    if (root._lpBedsGalleryIndex >= items.length) {
      root._lpBedsGalleryIndex = 0;
    }

    root.dataset.lpBedsGalleryHandle = product && product.handle ? product.handle : '';

    stage.innerHTML = items.map(function (item, index) {
      var isActive = index === root._lpBedsGalleryIndex;
      return '' +
        '<div class="lp-shell__media-slide' + (isActive ? ' is-active' : '') + '" data-lp-beds-media-index="' + index + '">' +
        '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.imageAlt || product.title || '') + '">' +
        '</div>';
    }).join('');

    if (thumbs) {
      if (showProductMedia && items.length > 1) {
        thumbs.innerHTML = items.map(function (item, index) {
          var isActive = index === root._lpBedsGalleryIndex;
          return '' +
            '<button type="button" class="lp-shell__media-thumb' + (isActive ? ' is-active' : '') + '" data-lp-beds-thumb="' + index + '" aria-label="Show image ' + (index + 1) + '">' +
            '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.imageAlt || product.title || '') + '">' +
            '</button>';
        }).join('');
        thumbs.hidden = false;
      } else {
        thumbs.innerHTML = '';
        thumbs.hidden = true;
      }
    }

    var hasMultiple = showProductMedia && items.length > 1;
    if (prevButton) prevButton.hidden = !hasMultiple;
    if (nextButton) nextButton.hidden = !hasMultiple;
  }

  function renderBedsSwatches(root, product, selectedVariant, group) {
    var wrappers = root.querySelectorAll('[data-lp-beds-swatch-group]');
    var label = root.dataset.variantTitleLabel || root.dataset.cardSwatchLabel || 'Color';
    var variants = product && product.variants ? product.variants : [];

    wrappers.forEach(function (wrapper) {
      if (!variants.length || (variants.length === 1 && variants[0].title === 'Default Title')) {
        wrapper.innerHTML = '';
        wrapper.hidden = true;
        return;
      }

      var html = '<div class="lp-shell__swatch-label">' + escapeHtml(label) + '</div>';
      variants.forEach(function (variant) {
        var isActive = selectedVariant && String(variant.id) === String(selectedVariant.id);
        html += '' +
          '<button type="button" class="lp-shell__swatch' + (isActive ? ' is-active' : '') + '"' +
          ' data-lp-beds-variant-choice="' + escapeHtml(variant.title) + '"' +
          (variant.available ? '' : ' disabled') +
          ' aria-pressed="' + (isActive ? 'true' : 'false') + '">' +
          '<span class="lp-shell__swatch-chip" style="--swatch-color: ' + escapeHtml(variant.swatchColor || '#d9d4cb') + ';"></span>' +
          '<span>' + escapeHtml(variant.title) + '</span>' +
          '</button>';
      });

      wrapper.innerHTML = html;
      wrapper.hidden = false;
    });
  }

  function renderBedsPrice(root, variant) {
    root.querySelectorAll('[data-product-price]').forEach(function (node) {
      node.innerHTML = formatMoney(variant.price);
    });

    root.querySelectorAll('[data-product-compare]').forEach(function (node) {
      if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
        node.innerHTML = formatMoney(variant.compareAtPrice);
        node.hidden = false;
      } else {
        node.hidden = true;
      }
    });

    root.querySelectorAll('[data-product-save]').forEach(function (node) {
      var saveText = buildSaveText({
        price: variant.price,
        compare_at_price: variant.compareAtPrice
      });
      node.textContent = saveText;
      node.hidden = !saveText;
    });
  }

  function renderBedsVariantLabel(root, selectedVariant) {
    var titleLabel = root.dataset.variantTitleLabel || 'Color';
    root.querySelectorAll('[data-variant-title]').forEach(function (node) {
      if (selectedVariant && selectedVariant.title && selectedVariant.title !== 'Default Title') {
        node.textContent = titleLabel + ': ' + selectedVariant.title;
        node.hidden = false;
      } else {
        node.hidden = true;
      }
    });
  }

  function renderBedsImage(root, product, selectedVariant) {
    var src = (selectedVariant && selectedVariant.image) || (product && product.image) || '';
    var alt = (selectedVariant && selectedVariant.imageAlt) || (product && product.imageAlt) || '';

    root.querySelectorAll('[data-product-image]').forEach(function (node) {
      if (!src) return;
      node.src = src;
      node.alt = alt;
      node.removeAttribute('srcset');
      node.removeAttribute('sizes');
    });
  }

  function renderBedsForm(root, selectedVariant) {
    root.querySelectorAll('[data-variant-id-input]').forEach(function (input) {
      input.value = selectedVariant.id;
      input.disabled = !selectedVariant.available;
    });

    root.querySelectorAll('[data-add-to-cart-button]').forEach(function (button) {
      syncBedsButton(button, {
        available: selectedVariant.available
      });
    });
  }

  function renderBedsHero(root, product, selectedVariant, group) {
    renderBedsGallery(root, product, selectedVariant, group);
    renderBedsPrice(root, selectedVariant);
    renderBedsSwatches(root, product, selectedVariant, group);
    renderBedsVariantLabel(root, selectedVariant);
    renderBedsForm(root, selectedVariant);

    root.querySelectorAll('[data-product-title]').forEach(function (node) {
      node.textContent = product.displayTitle || product.title;
    });

    root.querySelectorAll('[data-space-choice]').forEach(function (button) {
      var isActive = button.dataset.spaceChoice === group.state.space;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    root.querySelectorAll('[data-height-choice]').forEach(function (button) {
      var isActive = button.dataset.heightChoice === group.state.height;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function renderBedsSticky(root, product, selectedVariant, group) {
    renderBedsPrice(root, selectedVariant);
    renderBedsSwatches(root, product, selectedVariant, group);
    renderBedsVariantLabel(root, selectedVariant);
    renderBedsForm(root, selectedVariant);

    root.querySelectorAll('[data-product-title]').forEach(function (node) {
      node.textContent = product.displayTitle || product.title;
    });
  }

  function renderBedsCard(root, group) {
    var spaceKey = root.dataset.spaceKey;
    var handle = group.state.height === 'standard' ? root.dataset.standardHandle : root.dataset.extraTallHandle;
    var product = group.catalog.products[spaceKey + '-' + group.state.height];
    if (!product || !handle) return;

    var selectedVariant = getBedsVariant(product, group);

    renderBedsImage(root, product, selectedVariant);
    renderBedsPrice(root, selectedVariant);
    renderBedsSwatches(root, product, selectedVariant, group);
    renderBedsForm(root, selectedVariant);

    root.classList.toggle('is-selected', spaceKey === group.state.space);
    root.querySelectorAll('[data-product-title]').forEach(function (node) {
      node.textContent = product.displayTitle || product.title;
    });
    root.querySelectorAll('[data-product-height-label]').forEach(function (node) {
      node.textContent = group.state.height === 'standard' ? 'Standard height · 15"' : 'Extra tall · 29"';
    });
  }

  function renderBedsGroup(group) {
    if (!group.catalog || !group.catalog.products) return;

    var product = getBedsProduct(group);
    if (!product) return;

    var selectedVariant = getBedsVariant(product, group);
    if (!selectedVariant) return;

    group.state.variantTitle = selectedVariant.title;
    group.state.variantId = String(selectedVariant.id);

    group.roots.forEach(function (entry) {
      if (entry.component === 'hero') {
        renderBedsHero(entry.root, product, selectedVariant, group);
      } else if (entry.component === 'sticky') {
        renderBedsSticky(entry.root, product, selectedVariant, group);
      } else if (entry.component === 'cards') {
        entry.root.querySelectorAll('[data-lp-beds-card]').forEach(function (card) {
          renderBedsCard(card, group);
        });
      }
    });
  }

  function setBedsSelection(group, nextState) {
    group.state = Object.assign({}, group.state, nextState || {});
    renderBedsGroup(group);
  }

  function initBedsRoot(root) {
    if (!root || root.dataset.lpBedsReady === 'true') return;
    root.dataset.lpBedsReady = 'true';

    var groupKey = root.dataset.lpBedsGroup || 'beds-default';
    if (!bedsGroups[groupKey]) {
      bedsGroups[groupKey] = {
        catalog: null,
        roots: [],
        state: {
          space: root.dataset.initialSpace || 'large',
          height: root.dataset.initialHeight || 'extra-tall',
          variantTitle: root.dataset.initialVariantTitle || '',
          variantId: '',
          hasInteracted: false
        }
      };
    }

    var group = bedsGroups[groupKey];
    var catalog = parseJsonNode(root, '[data-lp-beds-catalog]', null);
    if (catalog && catalog.products) {
      group.catalog = catalog;
      group.state.space = group.state.space || catalog.defaultSpace || 'large';
      group.state.height = group.state.height || catalog.defaultHeight || 'extra-tall';
    }

    group.roots.push({
      root: root,
      component: root.dataset.lpBedsComponent || ''
    });

    root.addEventListener('click', function (event) {
      var spaceChoice = event.target.closest('[data-space-choice]');
      if (spaceChoice) {
        setBedsSelection(group, { space: spaceChoice.dataset.spaceChoice, hasInteracted: true });
        return;
      }

      var heightChoice = event.target.closest('[data-height-choice]');
      if (heightChoice) {
        setBedsSelection(group, { height: heightChoice.dataset.heightChoice, hasInteracted: true });
        return;
      }

      var variantChoice = event.target.closest('[data-lp-beds-variant-choice]');
      if (variantChoice) {
        if (variantChoice.disabled) return;
        setBedsSelection(group, { variantTitle: variantChoice.dataset.lpBedsVariantChoice, hasInteracted: true });
        return;
      }

      var thumbChoice = event.target.closest('[data-lp-beds-thumb]');
      if (thumbChoice) {
        root._lpBedsGalleryIndex = Number(thumbChoice.dataset.lpBedsThumb || 0);
        renderBedsGroup(group);
        return;
      }

      var prevChoice = event.target.closest('[data-lp-beds-gallery-prev]');
      if (prevChoice) {
        var prevProduct = getBedsProduct(group);
        var prevItems = prevProduct && prevProduct.media ? prevProduct.media : [];
        if (prevItems.length > 1) {
          root._lpBedsGalleryIndex = (Number(root._lpBedsGalleryIndex || 0) - 1 + prevItems.length) % prevItems.length;
          renderBedsGroup(group);
        }
        return;
      }

      var nextChoice = event.target.closest('[data-lp-beds-gallery-next]');
      if (nextChoice) {
        var nextProduct = getBedsProduct(group);
        var nextItems = nextProduct && nextProduct.media ? nextProduct.media : [];
        if (nextItems.length > 1) {
          root._lpBedsGalleryIndex = (Number(root._lpBedsGalleryIndex || 0) + 1) % nextItems.length;
          renderBedsGroup(group);
        }
        return;
      }

      var cardSelect = event.target.closest('[data-lp-beds-card-select], [data-lp-beds-card]');
      if (cardSelect) {
        var card = event.target.closest('[data-lp-beds-card]');
        if (card && card.dataset.spaceKey) {
          setBedsSelection(group, { space: card.dataset.spaceKey, hasInteracted: true });
        }
      }
    });

    root.querySelectorAll('form').forEach(function (form) {
      form.addEventListener('submit', function () {
        var card = form.closest('[data-lp-beds-card]');
        if (card && card.dataset.spaceKey) {
          setBedsSelection(group, { space: card.dataset.spaceKey, hasInteracted: true });
        }
      });
    });

    if (group.catalog) {
      renderBedsGroup(group);
    }
  }

  function initProductRoot(root) {
    if (!root || root.dataset.lpReady === 'true') return;
    root.dataset.lpReady = 'true';

    var variants = parseVariants(root);
    if (!variants.length) return;
    var variantContentById = parseVariantContent(root);
    var variantHeadingById = parseVariantHeadings(root);

    var groupKey =
      root.dataset.lpProductGroup ||
      root.id ||
      root.dataset.sectionId ||
      'lp-root-' + Math.random().toString(36).slice(2);

    if (!groups[groupKey]) {
      groups[groupKey] = {
        byId: {},
        variants: [],
        roots: [],
        currentVariantId: ''
      };
    }

    var group = groups[groupKey];

    variants.forEach(function (variant) {
      var key = String(variant.id);
      group.byId[key] = Object.assign({}, group.byId[key] || {}, variant);
    });

    group.variants = Object.keys(group.byId).map(function (key) {
      return group.byId[key];
    });

    var idInputs = root.querySelectorAll('[data-variant-id-input]');
    var quantityInputs = root.querySelectorAll('[data-quantity-input]');
    var variantTitleNodes = root.querySelectorAll('[data-variant-title]');
    var priceNodes = root.querySelectorAll('[data-product-price]');
    var compareNodes = root.querySelectorAll('[data-product-compare]');
    var saveNodes = root.querySelectorAll('[data-product-save]');
    var imageNodes = root.querySelectorAll('[data-product-image]');
    var variantContentTargets = root.querySelectorAll('[data-variant-content-target]');
    var variantHeadingNodes = root.querySelectorAll('[data-variant-heading]');
    var buttonNodes = root.querySelectorAll('[data-add-to-cart-button]');
    var choiceNodes = root.querySelectorAll('[data-variant-choice], [data-variant-card]');
    var selectNode = root.querySelector('[data-variant-select]');
    var mediaGallery = initMediaGallery(root);
    var defaultImage = root.dataset.defaultImage || '';
    var defaultImageAlt = root.dataset.defaultImageAlt || '';
    var defaultMediaKey = root.dataset.defaultMediaKey || '';
    if (defaultMediaKey) {
      root.dataset.lpMediaLock = 'true';
    }
    var variantTitle = root.dataset.variantTitle || 'Selected option';
    var currentVariantId = String(root.dataset.initialVariantId || '');
    var isVirtualBundle = root.dataset.virtualBundle === 'true';
    var bundleQuantity = root.dataset.bundleQuantity || '';

    function getVariantById(variantId) {
      return group.byId[String(variantId)] || null;
    }

    function updateDom(variant, shouldSyncControl) {
      var selectedVariantId = String(variant.id);
      root.dataset.initialVariantId = selectedVariantId;

      idInputs.forEach(function (input) {
        input.value = String(variant.cart_variant_id || variant.id);
        input.disabled = !variant.available;

        if (isVirtualBundle) {
          input.dataset.isVirtualBundle = 'true';
          if (bundleQuantity) input.dataset.bundleQuantity = bundleQuantity;
        }
      });

      quantityInputs.forEach(function (input) {
        input.value = input.value || '1';
      });

      variantTitleNodes.forEach(function (node) {
        if (variant.title && variant.title !== 'Default Title') {
          node.textContent = variantTitle + ': ' + variant.title;
          node.hidden = false;
        } else {
          node.hidden = true;
        }
      });

      priceNodes.forEach(function (node) {
        node.innerHTML = formatMoney(variant.price);
      });

      compareNodes.forEach(function (node) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          node.innerHTML = formatMoney(variant.compare_at_price);
          node.hidden = false;
        } else {
          node.hidden = true;
        }
      });

      saveNodes.forEach(function (node) {
        var saveText = buildSaveText(variant);
        if (saveText) {
          node.textContent = saveText;
          node.hidden = false;
        } else {
          node.hidden = true;
        }
      });

      variantContentTargets.forEach(function (node) {
        var contentHtml = variantContentById[selectedVariantId];
        if (typeof contentHtml === 'string' && contentHtml.length) {
          node.innerHTML = contentHtml;
        }
      });

      variantHeadingNodes.forEach(function (node) {
        var headingText = variantHeadingById[selectedVariantId];
        if (typeof headingText === 'string' && headingText.length) {
          node.textContent = headingText;
        }
      });

      if (mediaGallery) {
        if (root.dataset.lpMediaLock === 'true' && defaultMediaKey) {
          mediaGallery.setActive(defaultMediaKey);
          root.dataset.lpMediaInitialized = 'true';
        } else if (variant.featured_media_id) {
          mediaGallery.setActive(variant.featured_media_id);
        } else if (defaultMediaKey) {
          mediaGallery.setActive(defaultMediaKey);
        }
      } else {
        imageNodes.forEach(function (node) {
          function setImageSource(src, alt) {
            if (!src) return;
            node.src = src;
            node.alt = alt || '';
            // Clear any original responsive candidates so the browser doesn't keep
            // selecting the stale source after a variant-driven image swap.
            node.removeAttribute('srcset');
            node.removeAttribute('sizes');
          }

          if (root.dataset.lpMediaLock === 'true' && defaultImage) {
            setImageSource(defaultImage, defaultImageAlt);
            root.dataset.lpMediaInitialized = 'true';
          } else if (variant.image) {
            setImageSource(variant.image, variant.image_alt || variant.title || defaultImageAlt);
          } else if (defaultImage) {
            setImageSource(defaultImage, defaultImageAlt);
          }
        });
      }

      buttonNodes.forEach(function (button) {
        syncButtonState(button, variant);
      });

      choiceNodes.forEach(function (choice) {
        var isActive = choice.dataset.variantId === selectedVariantId;
        choice.classList.toggle('is-active', isActive);
        choice.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (shouldSyncControl !== false && selectNode) {
        selectNode.value = selectedVariantId;
      }
    }

    function updateVariant(variantId, shouldSyncControl) {
      var variant = getVariantById(variantId);

      if (!variant) {
        variant = group.variants.find(function (item) {
          return item.available;
        }) || group.variants[0];
      }

      group.currentVariantId = String(variant.id);
      group.roots.forEach(function (instance) {
        instance.updateDom(variant, shouldSyncControl);
      });
    }

    group.roots.push({
      root: root,
      updateDom: updateDom
    });

    choiceNodes.forEach(function (choice) {
      choice.addEventListener('click', function () {
        root.dataset.lpMediaLock = 'false';
        updateVariant(choice.dataset.variantId, true);
      });
    });

    if (selectNode) {
      selectNode.addEventListener('change', function () {
        root.dataset.lpMediaLock = 'false';
        updateVariant(selectNode.value, false);
      });
    }

    updateVariant(group.currentVariantId || currentVariantId || (selectNode && selectNode.value), true);
  }

  function initCartState(container) {
    var scope = container || document;
    var cartLinks = scope.querySelectorAll('[data-lp-view-cart]');
    if (!cartLinks.length) return;
    var shouldSkipInitialFetch = Array.prototype.some.call(cartLinks, function (link) {
      return link.dataset.lpHideUntilAdd === 'true';
    });

    function applyCartState(cart) {
      cartLinks.forEach(function (link) {
        var count = Number(cart && cart.item_count ? cart.item_count : 0);
        link.hidden = count < 1;

        var countNodes = link.querySelectorAll('[data-lp-cart-count]');
        countNodes.forEach(function (node) {
          node.textContent = count;
        });
      });
    }

    function fetchCart() {
      var cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';

      fetch(cartUrl + '.js')
        .then(function (response) {
          return response.json();
        })
        .then(applyCartState)
        .catch(function (error) {
          console.error('[landing-page-templates] Unable to fetch cart', error);
        });
    }

    if (!shouldSkipInitialFetch) {
      fetchCart();
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData && typeof event.cartData.item_count === 'number') {
          applyCartState(event.cartData);
        } else {
          fetchCart();
        }
      });
    }
  }

  function initTopbars(container) {
    var scope = container || document;
    var bars = scope.querySelectorAll('[data-lp-topbar]');
    if (!bars.length) return;

    bars.forEach(function (bar) {
      if (bar.dataset.lpTopbarReady === 'true') return;
      bar.dataset.lpTopbarReady = 'true';

      function measureBar() {
        document.documentElement.style.setProperty('--lp-topbar-offset', bar.offsetHeight + 'px');
      }

      function updateState() {
        var isScrolled = window.scrollY > 8;
        bar.classList.toggle('is-compact', isScrolled);
      }

      measureBar();
      updateState();

      window.addEventListener('resize', measureBar);
      window.addEventListener('scroll', updateState, { passive: true });
      window.addEventListener('resize', updateState);
    });
  }

  function initStickyBars(container) {
    var scope = container || document;
    var bars = scope.querySelectorAll('[data-lp-sticky-bar]');

    bars.forEach(function (bar) {
      if (bar.dataset.lpStickyReady === 'true') return;
      bar.dataset.lpStickyReady = 'true';

      var shell = bar.closest('[data-lp-shell]');
      var triggerKey = bar.dataset.lpTriggerId || '';
      var trigger = null;
      if (triggerKey) {
        trigger = document.querySelector('[data-lp-hero-trigger-id="' + triggerKey + '"]');
      }
      if (!trigger && shell) {
        trigger = shell.querySelector('[data-lp-hero-trigger]');
      }
      var desktopQuery = window.matchMedia('(min-width: 750px)');

      function setDesktopState() {
        if (!desktopQuery.matches) {
          bar.classList.add('is-visible');
          return;
        }

        if (!trigger) {
          bar.classList.add('is-visible');
          return;
        }

        var rect = trigger.getBoundingClientRect();
        bar.classList.toggle('is-visible', rect.bottom <= 0);
      }

      setDesktopState();
      window.addEventListener('scroll', setDesktopState, { passive: true });
      window.addEventListener('resize', setDesktopState);
    });
  }

  function initCountdowns(container) {
    var scope = container || document;
    var countdowns = scope.querySelectorAll('[data-lp-countdown]');

    countdowns.forEach(function (node) {
      if (node.dataset.lpCountdownReady === 'true') return;
      node.dataset.lpCountdownReady = 'true';

      var endValue = node.dataset.lpCountdownEnd;
      if (!endValue) return;
      var endDate = new Date(endValue);
      if (Number.isNaN(endDate.getTime())) return;

      function update() {
        var distance = endDate.getTime() - Date.now();
        if (distance <= 0) {
          node.hidden = true;
          return;
        }

        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        var daysNode = node.querySelector('[data-days]');
        var hoursNode = node.querySelector('[data-hours]');
        var minutesNode = node.querySelector('[data-minutes]');
        var secondsNode = node.querySelector('[data-seconds]');

        if (daysNode) daysNode.textContent = String(days).padStart(2, '0');
        if (hoursNode) hoursNode.textContent = String(hours).padStart(2, '0');
        if (minutesNode) minutesNode.textContent = String(minutes).padStart(2, '0');
        if (secondsNode) secondsNode.textContent = String(seconds).padStart(2, '0');
      }

      update();
      window.setInterval(update, 1000);
    });
  }

  function initAll(container) {
    (container || document).querySelectorAll('[data-lp-product-root]').forEach(initProductRoot);
    (container || document).querySelectorAll('[data-lp-beds-root]').forEach(initBedsRoot);
    initCartState(container || document);
    initTopbars(container || document);
    initStickyBars(container || document);
    initCountdowns(container || document);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
